import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { theme } from '@openx/components-core/lib/theme/theme.ts';

export const StyledTargetingPresetButton = styled(Button, {
  shouldForwardProp: prop =>
    !['isSubOption', 'isSelected', 'isDropdownOpen', 'isError', 'isDisabled'].includes(String(prop)),
})<StyledButtonProps>(({ isSubOption, isSelected, isDropdownOpen, isError, isDisabled }) => {
  const highlight = isDropdownOpen || (isSelected && !isError);
  const borderColor = isError
    ? theme.palette.error.main
    : highlight
      ? theme.palette.primary.border
      : theme.palette.background.grayLight;
  const isDropdownOpenLayout = isDropdownOpen && !isSubOption;

  const backgroundColor = isError
    ? theme.palette.error.light
    : isSubOption
      ? 'transparent'
      : highlight
        ? theme.palette.primary.light
        : theme.palette.background.boxLight;

  return {
    minWidth: 121,
    height: 44,
    padding: theme.spacing(1),
    width: '100%',
    borderRadius: isSubOption ? 0 : 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(0.75),
    textTransform: 'none',
    opacity: isDisabled && !isSelected ? 0.5 : 1,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.text.secondary,

    backgroundColor,
    border: isSubOption ? 'none !important' : `1px solid ${borderColor}`,

    ...(isDropdownOpenLayout && {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottom: 'none',
    }),

    '&:hover': {
      backgroundColor: isSubOption
        ? theme.palette.primary.light
        : isError
          ? theme.palette.error.light
          : highlight
            ? theme.palette.primary.light
            : theme.palette.background.antiflashWhite,
      border: isSubOption ? 'none !important' : `1px solid ${borderColor}`,
    },
  };
});

export type StyledButtonProps = {
  isSubOption?: boolean;
  isSelected?: boolean;
  isDropdownOpen?: boolean;
  isError?: boolean;
  isDisabled?: boolean;
};
